export const weddingFormDocQuestions = [
  {
    type: 'checkbox',
    text: 'Entendemos y aceptamos que es requisito haber finalizado exitosamente el Proyecto Matrimonio y estar actualmente activos en un grupo de discipulado.',
    options: ['Sí', 'No'],
    id: 'doc_question_1',
    radio: true,
  },
  {
    type: 'checkbox',
    text: 'Nos comprometemos a tener la cita de orientación bíblica prematrimonial antes de realizar el matrimonio civil. (En caso de ya estar casados legalmente, indicanos que no aplica y por favor envialo en PDF claro a este correo: gestion.comunidadmde@gmail.com)',
    options: ['Sí', 'No', 'No aplica'],
    id: 'doc_question_2',
    radio: true,
  },
  {
    type: 'checkbox',
    text: 'Nos comprometemos y nos hacemos responsables de entregar en físico, el registro civil de matrimonio autenticado por notaria, con un máximo de 4 días antes de la ceremonia.',
    options: ['Sí', 'No'],
    id: 'doc_question_3',
    radio: true,
  },
  {
    type: 'checkbox',
    text: 'Comprendemos que, si alguno de nosotros pertenece a otra iglesia local, debemos enviar al correo que nos faciliten, todos los documentos que avalen la realización de la ceremonia religiosa por parte de nuestra iglesia.',
    options: ['Sí', 'No'],
    id: 'doc_question_4',
    radio: true,
  },
  {
    type: 'checkbox',
    text: 'Nos comprometemos a que nuestra ceremonia religiosa cumpla con los principios y estándares cristianos, incluyendo la ceremonia misma, la celebración posterior, el vestuario de ambos y el de nuestros familiares.',
    options: ['Sí', 'No'],
    id: 'doc_question_5',
    radio: true,
  },
  {
    type: 'checkbox',
    text: 'Entendemos que bajo ninguna circunstancia, no se nos puede garantizar un Pastor específico para la ceremonia, y aceptamos con gratitud al Pastor que Comunidad nos asigne, y que este se contactará con nosotros para una llamada más logística, hasta 2 días antes de la ceremonia.',
    options: ['Sí', 'No'],
    id: 'doc_question_6',
    radio: true,
  },
  {
    type: 'checkbox',
    text: 'Somos conscientes de que la ceremonia religiosa no tiene un aporte económico establecido, pero asumimos con responsabilidad los viáticos del pastor (gasolina, peajes, alimentación u otros, según el caso) que deberán ser entregados directamente al Pastor el día de la ceremonia. Y si lo deseamos y está dentro de nuestras posibilidades, también estamos en libertad de entregar una ofrenda voluntaria directamente al Pastor.',
    options: ['Sí', 'No'],
    id: 'doc_question_7',
    radio: true,
  },
  {
    type: 'checkbox',
    text: 'Nos comprometemos a respetar con puntualidad el horario pactado para la ceremonia. Tomaremos todas las precauciones necesarias en la planificación previa (peinado, maquillaje, vestuario, transporte, congestión vehicular, entre otros) para evitar cualquier retraso.',
    options: ['Sí', 'No'],
    id: 'doc_question_8',
    radio: true,
  },
  {
    type: 'checkbox',
    text: 'Comprendemos que el envío de esta documentación no garantiza automáticamente la realización de nuestra ceremonia religiosa. Aceptamos que, en algunos casos, la iglesia puede considerar necesario que participemos en un proceso adicional antes de continuar.',
    options: ['Sí', 'No'],
    id: 'doc_question_9',
    radio: true,
  },
];
